import React from 'react';

import { Outlet, useNavigate } from 'react-router-dom';
import Typography from '../../components/Typography/Typography';

import ASSETS from '../../assets';

const AuthLayout = () => {
  const navigate = useNavigate();

  return (
    <div className='min-h-screen bg-white flex flex-col'>
      <div className='h-[168px]  bg-g_gradient'>
        <div className='h-full  pb-[51px] flex items-center justify-start gap-5 bg-f_gradient pl-10 hover:cursor-pointer' onClick={() => navigate('/')}>
          <img src={ASSETS.kpmg_logo} alt='' />
          <Typography variant='h3' color='white'>
            +
          </Typography>
          <img src={ASSETS.kresus_logo} alt='' />
        </div>
      </div>
      <div className='flex-grow flex flex-col  w-full bg-white '>
        <div className='flex-grow bg-white w-full shadow-auth_box  w-full mt-[-51px] flex flex-col'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
